<template>
	<z-backForm :name="'back-taskExam'" :align="true" @save="saveSet" @cancel="backSet" v-loading.fullscreen.lock="full_screenFlag">
		<!-- <div class="small-title">审核条件一</div> -->
		<div class="back-item">
			<div class="back-title" :class="{more:money_flag}">任务金额</div>
			<div class="back-wrap">
				<div class="switch-line">
					<el-switch v-model="money_flag" on-text="" off-text="">
					</el-switch>
					<div>启用审核限制</div>
				</div>
				<div v-show="money_flag" class="add">
					<el-input  class="top-choose" rule="number" v-tar="money_limit" v-model="money_limit">
					</el-input>
					<div class="tip">当任务奖金大于等于设置金额时，即需要审核</div>
				</div>
			</div>
		</div>

		<!-- <div class="small-title">审核条件二</div> -->
		<div class="back-item"  :style="{height:change_height}">
			<div class="back-title">任务类型</div>
			<div class="back-wrap check" ref="check">
				<div class="switch-line">
					<el-switch v-model="check_flag" on-text="" off-text="">
					</el-switch>
					<div>启用审核限制</div>
				</div>
				<div v-show="check_flag" class="add" ref="task-list">
					<el-checkbox-group  v-model="taskType_limit">
						<el-checkbox v-for="item in taskTpl" :label="item.id+''" :key="item.id">{{ item.tpl_name }}</el-checkbox>
					</el-checkbox-group>
					<!-- 隐藏的验证框 -->
					<input ref="checkInput" v-show="false" :rule="check_flag?'checkgroup':''" v-tar="taskType_limit_str" >
				</div>
			</div>
		</div>
	</z-backForm>
</template>

<script>
	import { mapState } from "vuex";

    export default {
		data(){
			return {
				money_limit:-1,  //审核金额额度
				taskType_limit:[],  //审核任务类型id数组
				check_flag:false,  //任务类型限制
				change_height:'auto',  //更改高度

				full_screenFlag:false,  //全屏遮罩
			}
		},
		computed:{
			...mapState(["taskTpl"]),
			money_flag:{
				get(){
					return this.money_limit == -1?false:true;
				},
				set(val){
					console.log(`flag:${val}`);
					if(val){
						this.money_limit = 0;
					}else{
						this.money_limit = -1;
					}

				},
			},
			taskType_limit_str(){
				return this.taskType_limit.join(',');
			},
		},
		watch:{
			taskType_limit(){
                this.$form.hideError(this.$refs["checkInput"]); 
			},
			check_flag(val){
				if(!val){  //关闭
					this.taskType_limit = [];
				}
				setTimeout(()=>{
					this.change_height = `${this.$refs["task-list"].offsetHeight+30}px`;	
				},0);
			},
		},

		created(){
            this.getData();
		},
		
		methods:{
			getData(){
				let url = "api/clerk/cfg_task";
                this.$http.get(url).then(res=>{
					if(res.status == 200){
						this.money_limit = res.res_data.apprCurrencyAmount;
						let arr = res.res_data.apprTemplateIds;
						this.taskType_limit =  arr?arr.split(","):[];
						this.check_flag = this.taskType_limit.length >0;
						this.$form.init("back-taskExam");
					}
                });
			},
			saveSet(){
				let url = `api/admin/cfg_task_admin_review`;
				let obj = {
					appr_currency_amount:this.money_limit,
					appr_template_id:this.taskType_limit.join(","),
				}

				this.full_screenFlag = true;
				this.$http.post(url,obj).then(res=>{
					if(res.status == 200){
						this.successTip("保存成功");
						this.getData();
					}
					this.full_screenFlag = false;
				}).catch(err=>{
					this.errorTip("保存失败");
					this.full_screenFlag = false;
				});
			},
			backSet(dataArr){
				this.getData();
			}
		}
	}
</script>

<style lang="less" scoped>
	@top:10px;
	.more{
		height: 60px + @top !important;
	}
	.switch-line{
		overflow: hidden;
		width:140px;
		>*{
			float:left;
		}
		>div{
			margin-left: 10px;
			margin-right: 0 !important;
		}
	}
	.add{
		position: relative;
		margin-top: @top;
	}
</style>





// WEBPACK FOOTER //
// task-exam.vue?0e0ddd06